import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BulkSummaryCards from "./BulkSummaryCards";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertThenFormat1,
  formatDateTime,
  getMonthYear,
} from "../../common-data/Converts";
import "../../../styles/payrole-system/payrole-table.css";
import { fetchEmployeePayrollData } from "../../../redux/payrole-reducers/payroleSlice";
import Loader from "../../ui/Loader";

const GymDetailsModal = ({
  userInfoData = {},
  onClose,
  rowData,
  prevAllFilters,
}) => {
  const dispatch = useDispatch();

  const { employeePayrollData, employeePayrollLoading, employeePayrollError } =
    useSelector((state) => state.payrole);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: rowData?.gym_id || "",
    user_approval: "approved",
    stack_holder_approval: "",
    month: prevAllFilters?.selectedMonth?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const [activeTab, setActiveTab] = useState("all");

  const iniStats = {
    allStats: {},
    tbStats: {},
  };
  const [statsData, setStatsData] = useState(iniStats);
  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const getAllCount = () => allDatas.allData.length;

  const getPendingCount = () =>
    allDatas.allData.filter((emp) => emp.stack_holder_approval === "pending")
      .length;

  const getApprovedCount = () =>
    allDatas.allData.filter((emp) => emp.stack_holder_approval === "approved")
      .length;

  const getRejectedCount = () =>
    allDatas.allData.filter((emp) => emp.stack_holder_approval === "rejected")
      .length;

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setFilters((prevs) => ({
      ...prevs,
      stack_holder_approval: tab === "all" ? "" : tab,
    }));
  };

  const getEmployeePayrollData = (filters) => {
    dispatch(
      fetchEmployeePayrollData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getEmployeePayrollData(filters);
  }, [filters]);

  useEffect(() => {
    if (
      !employeePayrollLoading &&
      !employeePayrollError &&
      employeePayrollData?.status &&
      employeePayrollData?.data?.length > 0
    ) {
      const {
        total_employee,
        pending_approval,
        ready_to_process,
        total_payout,
      } = employeePayrollData?.stats || {};

      setAllDatas((prevs) => ({
        ...prevs,
        allData: employeePayrollData.data,
        pagination:
          employeePayrollData?.pagination?.length > 0
            ? employeePayrollData.pagination
            : [],
      }));

      setStatsData((prevs) => ({
        ...prevs,
        allStats: {
          total_employee: total_employee || 0,
          pending_approval: pending_approval || 0,
          ready_to_process: ready_to_process || 0,
          total_payout: total_payout || 0,
        },
        tbStats: employeePayrollData?.stats || {},
      }));
    } else {
      setAllDatas(iniDatas);
      setStatsData(iniStats);
    }
  }, [employeePayrollLoading, employeePayrollError, employeePayrollData]);

  const columns = [
    {
      dataField: "date",
      text: "Payrole Month",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? getMonthYear(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "employee",
      text: "Employee",
      formatter: (_, row) => (
        <div className="pp-employee-payroll-employee-info">
          <p className="pp-employee-payroll-employee-name">
            {row?.name || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "account_type",
      text: "Role",
      formatter: (_, row) => (
        <span className="tb-data">{row?.account_type?.replace(/_/g, " ")}</span>
      ),
    },
    {
      dataField: "monthly_salary",
      text: "Monthly Salary",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat1(row?.monthly_salary)}
          </span>
        );
      },
    },
    {
      dataField: "net_salary",
      text: "Net Salary",
      formatter: (_, row) => (
        <span className="pp-employee-payroll-net-salary tb-data">
          ₹{convertThenFormat1(row?.net_salary)}
        </span>
      ),
    },
    {
      dataField: "stack_holder_approval",
      text: "Approval Status",
      formatter: (_, row) => (
        <span
          className={`pp-employee-payroll-badge ${
            row?.stack_holder_approval === "approved"
              ? "pp-green-badge"
              : row?.user_approval === "pending" ||
                row?.stack_holder_approval === "pending"
              ? "pp-yellow-badge"
              : "pp-red-badge"
          }`}
        >
          {row?.user_approval === "pending"
            ? "Review Required"
            : row?.stack_holder_approval || "NA"}
        </span>
      ),
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    // {
    //   dataField: "actions",
    //   text: "Actions",
    //   formatter: (_, row) => {
    //     return (
    //       <div className="pp-employee-payroll-actions">
    //         {renderActionButton(row, isStaff, handleApprovalClick)}
    //       </div>
    //     );
    //   },
    // },
  ];

  return (
    <div className="pp-modal-overlay" onClick={onClose}>
      <div
        className="pp-modal-container pp-gym-details-modal mod-width-70p mod-height-95vh"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pp-modal-header">
          <div className="pp-modal-header-left">
            <button
              className="pp-back-btn"
              onClick={onClose}
              aria-label="Back to overview"
            >
              ← Back to Overview
            </button>
            <div className="pp-modal-title-section">
              <h1 className="pp-modal-title">
                {rowData?.gym_name || "Gym Details"}
              </h1>
              <p className="pp-modal-subtitle">
                {statsData.allStats?.total_employee} employees · ₹
                {convertThenFormat1(statsData.allStats?.total_payout)} total
                payout
              </p>
            </div>
          </div>
          <button
            className="pp-close-btn pp-btn-outline"
            onClick={onClose}
            aria-label="Close modal"
          >
            Close
          </button>
        </div>

        <div className="pp-wrapper pp-history-container">
          <BulkSummaryCards
            statsData={statsData.allStats}
            classname="pp-gym-details-flex"
          />
        </div>

        <div className="pp-modal-table-section">
          <div className="pp-tab-toggle">
            <button
              className={`pp-tab-toggle-btn ${
                activeTab === "all"
                  ? "pp-tab-toggle-active"
                  : "pp-tab-toggle-inactive"
              }`}
              onClick={() => handleTabChange("all")}
            >
              All ({getAllCount()})
            </button>
            <button
              className={`pp-tab-toggle-btn ${
                activeTab === "pending"
                  ? "pp-tab-toggle-active"
                  : "pp-tab-toggle-inactive"
              }`}
              onClick={() => handleTabChange("pending")}
            >
              Pending ({getPendingCount()})
            </button>
            <button
              className={`pp-tab-toggle-btn ${
                activeTab === "approved"
                  ? "pp-tab-toggle-active"
                  : "pp-tab-toggle-inactive"
              }`}
              onClick={() => handleTabChange("approved")}
            >
              Approved ({getApprovedCount()})
            </button>
            <button
              className={`pp-tab-toggle-btn ${
                activeTab === "rejected"
                  ? "pp-tab-toggle-active"
                  : "pp-tab-toggle-inactive"
              }`}
              onClick={() => handleTabChange("rejected")}
            >
              Rejected ({getRejectedCount()})
            </button>
          </div>

          <div className="pp-employee-payroll-table-wrapper pp-no-border-table mt30">
            {employeePayrollLoading ? (
              <Loader />
            ) : (
              <PaymentLinkTable
                tableData={allDatas.allData}
                tableColumns={columns}
                tablePagination={allDatas.pagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GymDetailsModal;
